import React from 'react'
import { useTranslation } from 'react-i18next'
import Mockup from "../assets/mockup-2.png"

const TradingPlatformsComponents = () => {
    const { t } = useTranslation();

    return (
        <div className='about-us-component-content trading-platforms-component-content'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-2">
                        <h4>{t('İşlem Platformları')}</h4>
                    </div>
                    <div className="col-lg-6">
                        <h3 className='mb-4'>{t('Paragon Yatırım İşlem Platformları: Güvenli ve Hızlı Ticaret')}</h3>
                        <p className="mb-2">
                            {t('Paragon Yatırım, yatırımcılarına en iyi ticaret deneyimini sunmak için gelişmiş ve kullanıcı dostu işlem platformları sağlar. İster masaüstü, ister mobil cihaz üzerinden işlem yapın, platformlarımız her zaman erişilebilir ve güvenlidir. Anlık piyasa verileri, teknik analiz araçları ve gelişmiş grafik özellikleri ile yatırımcılar, piyasaları daha iyi takip edebilir ve bilinçli kararlar alabilirler.')}
                        </p>
                        <p className="mb-0">
                            {t('Platformlarımız, hız ve güvenliği ön planda tutarak, yatırımcıların işlemlerini kesintisiz bir şekilde gerçekleştirmelerini sağlar. Paragon Yatırım, kullanıcılarına aynı zamanda kişiselleştirilmiş işlem alanları ve gelişmiş risk yönetim araçları sunarak, yatırım süreçlerini daha verimli hale getirir. İster yeni başlayan, ister deneyimli bir yatırımcı olun, platformlarımız her seviyeye uygun özellikler sunar.')}
                        </p>
                    </div>
                    <div className="col-lg-4 mt-lg-0 mt-4" style={{ backgroundImage: 'url("https://templatekit.jegtheme.com/digipay/wp-content/uploads/sites/385/2023/06/bg-line-circle-digipay.png")', backgroundColor: "#D8F6EE", borderRadius: 10, backgroundPosition: "center", backgroundSize: "cover", display: "flex", alignItems: "center", justifyContent: "center", paddingTop: 50 }}>
                        <img src={Mockup} alt="" width="175px" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TradingPlatformsComponents